import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { PaginatorState } from 'primeng/paginator';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { ProductControllerGetAll$Params } from 'src/app/api/fn/product/product-controller-get-all';
import { AgreementProductItem } from 'src/app/api/models';
import { ProductService } from 'src/app/api/services';

interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}

@Component({
  selector: 'app-modal-agreement-prod-picker',
  templateUrl: './modal-agreement-prod-picker.component.html',
  styleUrls: ['./modal-agreement-prod-picker.component.scss'],
})
export class ModalAgreementProdPickerComponent {
  readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  @ViewChild('keywordFilter') keywordFilter?: ElementRef<HTMLInputElement>;
  @ViewChild('dt1') table?: Table;

  question_title: string;
  chosenProducts?: AgreementProductItem[] = [];

  products: AgreementProductItem[] = [];
  productsId?: number;
  loading: boolean = false;
  totalRecords: number = 0;
  selectedProduct: AgreementProductItem[] = [];
  queryRole?: any;
  first: number = 0;
  rows: number = this.rowsPerPageOptions[0];
  pickerType?: string;
  selectedProductControl = new FormControl(null);
  disabledReasons: Record<number, string> = {};

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private prodService: ProductService
  ) {
    this.question_title = config.data!.question_title;
    this.chosenProducts = config.data!.chosenProducts;
    this.products = config.data!.products;
    // if (this.chosenProducts) {
    //   this.selectedProduct = this.chosenProducts;
    //   this.totalRecords = this.products.length;
    // }
    this.selectedProduct = [...(this.chosenProducts ?? [])];
    this.pickerType = config.data.pickerType;
    this.disabledReasons = config.data.disabledReasons ?? {};
  }

  getDisabledReason(p: AgreementProductItem): string | undefined {
    return this.disabledReasons[p.id] ?? undefined;
  }

  clear(table: Table) {
    table.clear();
    if (this.keywordFilter) {
      this.keywordFilter.nativeElement.value = '';
    }
  }

  close() {
    this.ref.close();
  }

  save() {
    this.pickerType === 'radio'
      ? this.ref.close({ value: this.selectedProductControl.value })
      : this.ref.close({ value: this.selectedProduct });
  }

  checkIfProdIsChosen(p: AgreementProductItem) {
    if (this.chosenProducts) {
      return this.chosenProducts?.some(cp => cp.id === p.id);
    }
    return false;
  }

  loadProducts() {
    this.loading = true;
    if (this.chosenProducts) {
      this.selectedProduct = [...this.chosenProducts];
    }
  }
}
